module.exports = __webpack_public_path__ + "img/jfrog.365d7140.png";